import { Component, OnInit, Injector, Input, Output, EventEmitter } from '@angular/core';
import { SecretaryInterface, languageI, qualificationI } from 'app/core/interfaces/secretary';
import { dadosLoginI, dadosLoginInitialState } from 'app/core/interfaces/login';
import { addressI, addressInitialState } from 'app/core/interfaces/adress';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SecretaryService } from 'app/core/http/services/secretary.service';
import { CognitoService } from 'app/core/http/services/cognito.service';
import { cpfValidator } from 'app/core/validators/CpfValidator';
import { HttpErrorResponse } from '@angular/common/http';
import { validateImageFile } from 'app/core/validators/validateImageFile';
import { ageValidator } from 'app/core/validators/AgeValidator';

@Component({
  selector: 'secretary-registration',
  templateUrl: './secretary-registration.component.html',
  styleUrls: ['./secretary-registration.component.scss'],
})
export class SecretaryRegistrationComponent extends BaseComponent implements OnInit {
  public form: FormGroup;
  public address: addressI = addressInitialState;
  public qualifications: qualificationI[] = [];
  public courses: qualificationI[] = [];
  public languages: languageI[] = [];
  public dadosLogin: dadosLoginI = dadosLoginInitialState;
  public userEmail: string = '';

  @Input() secretary!: SecretaryInterface;
  @Input() mode: string = 'CREATE';

  @Output() onUpdateSecretary = new EventEmitter<any>();

  public validForm = false;

  profilePictureUrl: string | ArrayBuffer | null = null;
  selectedFileName: string | null = null;

  public get fields(): any[] {
    const secretary: any = this.secretary;
    return Object.keys(this.secretary).map((field: string) => {
      const valid = secretary[field] != '';
      return { field, value: valid };
    });
  }

  constructor(
    private fb: FormBuilder,
    private injector: Injector,
    private secretarysService: SecretaryService,
    private cognitoService: CognitoService,
  ) {
    super(injector);

    this.form = this.fb.group({
      secretaries_id: new FormControl(null, [Validators.nullValidator]),
      name: new FormControl('', [Validators.required, Validators.pattern(/^[A-Za-zÀ-ÿ\s]+$/)]),
      email: new FormControl(this.userEmail, [Validators.nullValidator, Validators.email]),
      birthDate: new FormControl('', [Validators.required, ageValidator(18, 120)]),
      cpf: new FormControl('', [Validators.required, cpfValidator]),
      mobile: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]{11}$/)]),
      status: new FormControl(true),
      photo: new FormControl(''),
    });
  }

  async ngOnInit() {
    this.showSuccessMessage = false;
    this.showErrorMessage = false;
    this.getUserEmail();

    await this.createOrUpdate();

    if (this.mode == 'UPDATE' && localStorage.getItem('isFirstAccess') == 'false') this.getSecretary();

    if (this.mode == 'CREATE') {
      this.form.patchValue({
        name: this.secretary?.name,
        email: this.userEmail,
        birthDate: this.secretary?.birthDate,
        cpf: this.secretary?.cpf ?? '',
        mobile: this.secretary?.mobile,
        photo: this.secretary?.photo,
      });
    }
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    const photoControl = this.form.controls['photo'];

    if (!file) {
      return;
    }

    const validationResult = validateImageFile(file, 4);

    if (!validationResult.isValid) {
      photoControl.setErrors(validationResult.errors);
      this.profilePictureUrl = null;
      this.selectedFileName = null;

      return;
    }

    photoControl.setErrors(null);
    this.selectedFileName = file.name;

    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result) {
        const base64 = reader.result as string;
        this.profilePictureUrl = base64;
        this.form.controls['photo'].setValue(base64);
      }
    };
    reader.readAsDataURL(file);
  }

  private async getUserEmail() {
    const { standardAttributes } = await this.cognitoService.getUserAttributes();
    this.userEmail = standardAttributes['email'];

    this.form.patchValue({
      email: this.userEmail,
    });
  }

  async createOrUpdate() {
    const userAttributes = await this.cognitoService.getUserAttributes();
    const { standardAttributes, customAttributes } = userAttributes;
    const firstAccess = customAttributes['firstAccess'];
    localStorage.setItem('isFirstAccess', firstAccess);
    if (localStorage.getItem('isFirstAccess') == 'true') {
      this.mode = 'CREATE';
    } else {
      this.mode = 'UPDATE';
    }
  }

  private getSecretary() {
    const secretary_id = this.getUserLogged().id;

    this.secretarysService.showNew(secretary_id).subscribe({
      next: (secretary: SecretaryInterface) => {
        this.secretary = secretary;

        let formattedMobile = this.secretary.mobile || '';
        if (formattedMobile.startsWith('55')) {
          formattedMobile = formattedMobile.replace('55', '');
        }

        this.form.patchValue({
          secretaries_id: this.secretary?.secretaries_id,
          name: this.secretary?.name,
          email: this.userEmail,
          birthDate: this.secretary?.birthDate,
          cpf: this.secretary.cpf,
          mobile: formattedMobile,
          photo: this.secretary.photo,
        });

        this.profilePictureUrl = this.secretary.photo ?? this.defaultSecretaryPhoto;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  hasError(field: string) {
    const secretary: any = this.secretary;
    return secretary[field] == '' ? true : false;
  }

  async salvar() {
    this.loading = true;

    if (this.form.invalid) {
      this.showErrorMessage = true;
      this.showSuccessMessage = false;
      this.loading = false;
      return;
    }

    const secretary_id = this.getUserLogged().id;

    const secretararyFormData = {
      ...this.secretary,
      ...this.form.value,
    };

    this.secretarysService.updateNew(secretary_id, secretararyFormData).subscribe({
      next: (res) => {
        this.loading = false;
        this.showErrorMessage = false;
        this.showSuccessMessage = true;

        this.onUpdateSecretary.emit(res);
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.showErrorMessage = true;
        this.showSuccessMessage = false;

        if (err.status == 413) {
          this.messageError = 'Imagem enviada ultrapassa o tamanho máximo permitido de 4MB';
          return;
        }

        if (err.status == 422) {
          this.messageError = err.error.message;
          return;
        }

        this.messageError = err.error.message || err.message;
      },
    });
  }

  create() {
    this.loading = true;

    if (this.form.invalid) {
      this.showErrorMessage = true;
      this.showSuccessMessage = false;
      this.loading = false;
      return;
    }

    const secretaryFormValue = this.form.value;
    this.secretarysService.createNew(secretaryFormValue).subscribe({
      next: (secretary: SecretaryInterface) => {
        this.form.patchValue({
          secretary_id: secretary.secretaries_id,
        });

        this.auth.setUser(secretary, localStorage.getItem('userType'), localStorage.getItem('token'), localStorage.getItem('token_id'));

        this.loading = false;
        this.showErrorMessage = false;
        this.showSuccessMessage = true;

        this.onUpdateSecretary.emit(secretary);

        this.cognitoService.updateFirstAccess();

        setTimeout(() => {
          this.router.navigate(['secretarias-new/meus-dados'], { queryParams: { tab: 'localizacao' } });
          this.loading = false;
        }, 500);
      },

      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.showErrorMessage = true;
        this.showSuccessMessage = false;

        if (err.status == 413) {
          this.messageError = 'Imagem enviada ultrapassa o tamanho máximo permitido de 4MB';
          return;
        }

        if (err.status == 422) {
          this.messageError = err.error.message;
          return;
        }

        console.log(err);

        this.messageError = err.error.message || err.message;
      },
    });
  }
}
